// Doira bo'yicha FILTRLANGAN agent ro'yxati — tanlov oynalari uchun.
//
// ⚠️ NEGA ALOHIDA HOOK, HAR FORMADA `useQuery` EMAS
// Ro'yxat kamida uch joyda kerak bo'ladi (abonent yaratish, abonent
// tahrirlash, lidni abonentga aylantirish). Har biri o'zi so'rasa bir xil
// daraxt uch marta yuklanardi; kalit bitta bo'lgani uchun so'rov haqiqatda
// BITTA bo'ladi.
//
// ⚠️ FILTRNI PANEL O'YLAB TOPMAYDI — u SERVERDAN keladi
// `GET /api/agents/roots` va `/{id}/subtree` ikkalasi ham
// `guard.scopeFilter(AGENT_READ, AgentScope.COLUMNS)` dan o'tadi
// (`AgentController`). Ya'ni bu yerda "kimga qaysi agent ko'rinadi" degan
// mantiq TAKRORLANMAYDI. Uni takrorlash QARORLAR.md §19.8 da o'lchangan
// xatoning aynan o'zi bo'lardi: nusxa ajrashganda natija xato emas,
// JIMGINA BO'SH bo'ladi.
//
// ⚠️ VA U YAGONA HIMOYA EMAS. Ro'yxatni filtrlash — QULAYLIK: operator
// tanlay olmaydigan narsani ko'rmasin. Haqiqiy qorovul serverda:
// `SubscriberOwnership.requireNodeAllowed` begona tugunni 404 bilan rad
// etadi, hatto so'rov qo'lda yuborilgan bo'lsa ham. Ikkalasining doirasi
// bir xil bo'lishi SHART EMAS: `agent.read` keng, `subscriber.create` tor
// bo'lishi mumkin — bunda ro'yxatda ko'rinadigan agent tanlanganda server
// rad etadi, va bu to'g'ri tartib (ro'yxat hech qachon serverdan
// KENGROQ ruxsat bermaydi).

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { usePermissions } from '@/shared/auth/usePermissions'
import { fetchAgentTree, type AgentNode } from './agentApi'

export interface AgentIndexApi {
  agents: readonly AgentNode[]
  loading: boolean
  /**
   * Ro'yxat ISHONCHLIMI — ya'ni «agent yo'q» degan xulosa chiqarish
   * mumkinmi.
   *
   * ⚠️ Bo'sh ro'yxatning uch sababi bor va ular BIR XIL EMAS: hali
   * yuklanmagan, `agent.read` huquqi yo'q, yoki doirada chindan ham
   * agent yo'q. Faqat oxirgisida «agent yo'q» deyish rost —
   * qolganida u yolg'on bo'lardi (`useSiteIndex` dagi bilan bir xil
   * qoida va bir xil sabab).
   */
  reliable: boolean
}

export function useAgentIndex(enabled = true): AgentIndexApi {
  const { can } = usePermissions()
  const allowed = enabled && can('agent.read')

  const query = useQuery({
    queryKey: queryKeys.agents.tree,
    queryFn: fetchAgentTree,
    enabled: allowed,
    // Daraxt kunlab o'zgarmaydi — har forma ochilganda qayta so'rash
    // keraksiz shovqin.
    staleTime: 5 * 60_000,
  })

  return {
    agents: query.data ?? [],
    loading: allowed && query.isPending,
    reliable: allowed && query.isSuccess,
  }
}
